import ApiService from '@/utils/ApiService'

export default {
  namespaced: true,
  state: {
    error: '',
    isLoading: false,
    retrieved: null
  },
  getters: {
    error: (state) => state.error,
    isLoading: (state) => state.isLoading,
    retrieved: (state) => state.retrieved,
    getCustomFields (state) {
      if (state.retrieved && state.retrieved.customFields.length > 0) {
        state.retrieved.customFields = state.retrieved.customFields.filter(entry => entry.state === 1)
        return state.retrieved.customFields.map(customField => {
          let item = {
            name: customField.fieldName,
            value: '',
            options: [],
            type: customField.fieldType,
            required: Boolean(customField.fieldRequired),
            readonly: Boolean(customField.fieldReadonly),
            onlyNumbersAllowed: customField.onlyNumbersAllowed,
            allowedDaysAhead: customField.allowedDaysAhead,
            allowedDaysBack: customField.allowedDaysBack,
            minValue: customField.minValue,
            maxValue: customField.maxValue,
            disabledRoles: customField.disabledRoles,
            label: customField.fieldLabel
          }

          if (customField.fieldType === 'select' || customField.type === 'select') {
            if (customField.fieldValues.length > 0) {
              for (let v in customField.fieldValues) {
                let option = {
                  value: customField.fieldValues[v].value,
                  defaultValue: customField.fieldValues[v].defaultValue
                }
                item.options.push(option)
              }
            }
            if (item.options.length > 0) {
              for (let o in item.options) {
                if (item.options[o].defaultValue === 1) {
                  item.value = item.options[o]['value']
                }
              }
            }
          }
          if (item.type === 'multiSelect') {
            if (customField.fieldValues.length > 0) {
              item.value = []
              for (let v in customField.fieldValues) {
                let option = {
                  value: customField.fieldValues[v].value,
                  defaultValue: customField.fieldValues[v].defaultValue
                }
                item.options.push(option)
              }
            }
            if (item.options.length > 0) {
              for (let o in item.options) {
                if (item.options[o].defaultValue === 1) {
                  item.value.push(item.options[o]['value'])
                }
              }
            }
          }
          if (item.type === 'inputFormatted' && customField.fieldDefaultValue) {
            item.value = customField.fieldDefaultValue
          }
          if (item.type === 'itemsCollection') {
            item.value = []
          }
          if (item.type === 'idUserData') {
            item.displayValue = ''
            item.idUserDataClientTypes = customField.idUserDataClientTypes ? customField.idUserDataClientTypes : []
          }
          return item
        })
      } else return []
    }
  },
  mutations: {
    reset (state) {
      state.error = ''
      state.isLoading = false
      state.retrieved = null
    },
    setError (state, payload) {
      state.error = payload
    },
    toggleLoading (state) {
      state.isLoading = !state.isLoading
    },
    setRetrieved (state, payload) {
      state.retrieved = payload
    }
  },
  actions: {
    async retrieve ({ commit }, id) {
      commit('toggleLoading')
      const response = await new ApiService(id).getResults()
      commit('setRetrieved', await response)
      commit('toggleLoading')
    }
  }
}
